// Copyright (c) 2016 Deere & Company

import LaborRateHistoryReport from '../../../reports/labor-rate-history/state-connector';

export default {
    component: LaborRateHistoryReport,
    name: 'LABOR_RATE_HISTORY',
    path: 'labor-rate-history'
};




// WEBPACK FOOTER //
// ./src/routes/claims/reports/labor-rate-history.js